/*
 * @Author: Teemo Ding
 * @Date: 2022-08-30 16:23:34
 * @LastEditTime: 2022-09-07 15:17:46
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/AllOrders/OrderDetail/Refund/Components/RefundDetail/tool.ts
 */
import { accAdd, accSub } from 'src/tools/math';
interface IProps {
  transactions;
  shippingFee;
  showShippingFee;
  taxes;
  productSubTotal;
  storeCreditBalance;
}

export const calculatePrice = ({
  transactions,
  shippingFee,
  showShippingFee,
  taxes,
  productSubTotal,
  storeCreditBalance,
}: IProps) => {
  const transactionsValues = Object.values(transactions || {}).reduce(
    (pre: Array<number>, now) => {
      return pre.concat(Object.values(now).map((item: any) => item.refund));
    },
    [],
  ) as Array<number>;

  const totalRefund = transactionsValues.length
    ? transactionsValues.reduce((pre, now) => accAdd(pre, now || 0), 0)
    : 0;
  const totalRefundAddStoreCredit = accAdd(totalRefund, storeCreditBalance);
  const taxesFee = taxes.reduce((pre, now) => {
    if (now.checked) {
      return accAdd(pre, now.taxValue || 0);
    } else {
      return pre;
    }
  }, 0);
  const shippingFeeSubTotal = showShippingFee
    ? accAdd(productSubTotal, shippingFee)
    : productSubTotal;
  const subTotal = accAdd(shippingFeeSubTotal, taxesFee);
  const adjustment = accSub(subTotal, totalRefundAddStoreCredit);
  return { adjustment, totalRefund: totalRefundAddStoreCredit };
};
